import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
  answerBlock
} from 'actions';

import QuestionnaireType from 'common/questionnaires/QuestionnaireType';
import QuestionBlock from 'components/Questionnaires/QuestionBlock';
import Question from 'components/Questionnaires/Question';
import { QuestionTextField } from 'components/Questionnaires/fields';
import { QuestionGiinBlock } from 'components/Questionnaires/blocks';
import { validateQuestion, isEmptyObject, requiredValidator } from 'components/Questionnaires/validators';

export const QuestionCloselyHeldInvestmentVehicleBlock = ({ block }) => {
  const dispatch = useDispatch();
  const [answer, setAnswer] = useState(block?.answers ?? { });

  const [name, setName] = useState({
    id: 'name',
    component: QuestionTextField,
    label: 'questionnaire.ch4.investmentVehicle.name',
    info: {
      instructions: 'questionnaire.ch4.investmentVehicle.name.info'
    },
    validation: {
      conditions: [
        { condition: requiredValidator, message: 'questionnaire.ch4.investmentVehicle.name.errorMessage' }
      ]
    },
    visible: true
  });

  const [giin, setGiin] = useState({
    id: 'giin',
    component: QuestionGiinBlock,
    expandCollapse: false,
    className: 'p-0 no-border nested',
    visible: true
  });

  const blockIdentifier = useMemo(() => ((block && block.id) ? `${ block.id }${ block.index !== undefined ? (`.${ block.index }`) : '' }` : undefined), [block.index]);

  const isValid = () => giin.isValid && name.isValid;

  useEffect(() => {
    dispatch(answerBlock(block.id, answer, isValid()));
  }, [answer]);

  useEffect(() => {
    setAnswer(block.answers ?? {});
  }, [block.answers]);

  const onBlockAnswer = (b, a, v) => {
    switch (b.id) {
      case 'giin': {
        const newBlock = { ...b, ...{ answer: a, isValid: v } };
        setGiin(newBlock);
        setAnswer({ ...answer, giin: a });
        break;
      }
      default:
        break;
    }
  };

  const onQuestionChange = (q, value) => {
    switch (q.id) {
      case 'name': {
        const newName = { ...q, answer: value };
        validateQuestion(newName);
        setName(newName);
        setAnswer({ ...answer, name: value });
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    if (block.isForceEdited === true) {
      if (!giin.value || isEmptyObject(answer.giin)) {
        const newBlock = { ...giin, ...{ isForceEdited: true } };
        setGiin(newBlock);
      }
      if (!answer?.name) {
        onQuestionChange({ ...name, isForceEdited: true }, '');
      }
    }
  }, [block.isForceEdited]);

  return (<React.Fragment>
    <Question key={ name.id } blockId={ blockIdentifier } question={ name } { ...name.componentProps } onChange={ (q, a) => onQuestionChange(q, a) } />
    <div className="col-12">
      <QuestionBlock questionnaireType={ QuestionnaireType.Form } key={ `${ block.id }-${ giin.id }` } block={ giin } onAnswer={ onBlockAnswer } />
    </div>
  </React.Fragment>);
};

QuestionCloselyHeldInvestmentVehicleBlock.displayName = 'QuestionCloselyHeldInvestmentVehicleBlock';

QuestionCloselyHeldInvestmentVehicleBlock.propTypes = {
  block: PropTypes.shape().isRequired
};

QuestionCloselyHeldInvestmentVehicleBlock.defaultProps = {
};

export default QuestionCloselyHeldInvestmentVehicleBlock;
